module.exports = __webpack_public_path__ + "img/tree-07-f-trunk.953ed26e.png";